<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('links.Header') }}</h2>
                <br />
                <h3>{{ $t('links.References') }}</h3>
                <br />
                <br />
                <br />
                <center>
                    <table border="0">
                        <tr>
                            <td><a href="http://www.worldtaekwondo.org/" target="_blank"><img src="../images/links/wt.png" /></a></td>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td><a href="http://www.worldtaekwondo.org/" style="text-decoration:none;" target="_blank"><strong>{{ $t('links.WT') }}</strong></a></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td><a href="https://www.dtu.de/" target="_blank"><img src="../images/links/dtu.gif" /></a></td>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td><a href="https://www.dtu.de/" style="text-decoration:none;" target="_blank"><strong>{{ $t('links.DTU') }}</strong></a></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td><a href="https://www.nwtu.de/" target="_blank"><img src="../images/links/nwtu.gif" /></a></td>
                            <td></td>
                            <td><a href="https://www.nwtu.de/" style="text-decoration:none;" target="_blank"><strong>{{ $t('links.NWTU') }}</strong></a></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td><a href="https://www.lsb.nrw/" target="_blank"><img src="../images/links/lsb.jpg" /></a></td>
                            <td></td>
                            <td><a href="https://www.lsb.nrw/" style="text-decoration:none;" target="_blank"><strong>{{ $t('links.LSB') }}</strong></a></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td><a href="https://www.sport-in-bochum.de/" target="_blank"><img src="../images/links/stadtsportbundnet.gif" /></a></td>
                            <td></td>
                            <td><a href="https://www.sport-in-bochum.de/" style="text-decoration:none;" target="_blank"><strong>{{ $t('links.SSB') }}</strong></a></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td><a href="https://www.jugendring-bochum.de" target="_blank"><img src="../images/links/KinderJugendRingBochum.png" runat="server" /></a></td>
                            <td></td>
                            <td><a href="https://www.jugendring-bochum.de" style="text-decoration:none;" target="_blank"><strong>{{ $t('links.JRB') }}</strong></a></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td><a href="https://mitglieder.tsg-bochum.de" target="_blank"><img src="../images/links/TSGMitgliederPortalLink.png" runat="server" /></a></td>
                            <td></td>
                            <td><a href="https://mitglieder.tsg-bochum.de" style="text-decoration:none;" target="_blank"><strong>{{ $t('links.TSG') }}</strong></a></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                    </table>
                </center>
                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>